import { render, staticRenderFns } from "./statrgyManagerForm.vue?vue&type=template&id=84702e98&scoped=true"
import script from "./statrgyManagerForm.vue?vue&type=script&lang=js"
export * from "./statrgyManagerForm.vue?vue&type=script&lang=js"
import style0 from "./statrgyManagerForm.vue?vue&type=style&index=0&id=84702e98&prod&lang=scss&scoped=true"
import style1 from "./statrgyManagerForm.vue?vue&type=style&index=1&id=84702e98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84702e98",
  null
  
)

export default component.exports